module.exports = __webpack_public_path__ + "static/media/motion-sickness.5c32620d.png";